const features = [
  {
    icon: 'ri-shield-check-line',
    title: '完全免费',
    desc: '无需注册会员，无需付费订阅，所有电视剧全集免费在线观看，真正零门槛追剧体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅',
    desc: '多线路智能切换，自适应带宽，保证高清画质播放不卡顿缓冲，追剧体验一气呵成。',
  },
  {
    icon: 'ri-timer-line',
    title: '每日更新',
    desc: '同步全网最新剧集更新，热门电视剧第一时间上线，让你追剧永远快人一步。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '电脑、平板、手机全终端完美适配，随时随地打开浏览器就能追剧，方便快捷。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">平台优势</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么百万用户选择58影院？四大核心优势为您保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feat.icon} text-primary-600 group-hover:text-background-50 text-xl transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 font-heading mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}